import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { Card, Table, Stack, Avatar, TableRow, TableBody, TableCell, Container, Typography, TableContainer, Switch, Button, Select, MenuItem, TextField, FormControl, InputLabel, Grid } from "@mui/material";
import Page from "src/components/Page";
import Scrollbar from "src/components/Scrollbar";
import SearchNotFound from "src/components/SearchNotFound";
import personOutline from "@iconify/icons-eva/person-outline";
import { Icon } from "@iconify/react";
import plusFill from "@iconify/icons-eva/plus-fill";
import iconEdit from "@iconify/icons-eva/edit-2-fill";
import iconEdit2 from "@iconify/icons-eva/edit-2-outline";

import axios from "axios";
import MoreMenu from "src/components/common/MoreMenu";
import ListHead from "src/components/common/ListHead";
import ListToolbar from "src/components/common/ListToolbar";
import { alert } from "src/services/alert";
import MyPagination from "src/components/common/MyPagination";
import Confirm from "src/components/common/ConfirmDialog";
import TopupDialog from "src/components/dialogs/TopupDialog";
import PointTopupDialog from "src/components/dialogs/PointTopupDialog";
import UserChargeDialog from "src/components/dialogs/UserChargeDialog";
import UIAvatar from "src/components/common/UIAvatar";
import { asyncRequest } from "src/services/network";
import SharesDialog from "src/components/dialogs/SharesDialog";
import UserInfo from "src/components/common/UserInfo";
import PointReleaseDialog from "src/components/dialogs/PointReleaseDialog";
import SalaryDialog from "src/components/dialogs/SalaryDialog";
import TitleDialog from "src/components/dialogs/TitleDialog";
import TreeSelect from "src/components/lib/tree-select/TreeSelect";
import StaffAddDialog from "src/components/dialogs/StaffAddDialog";
import TiejunAddDialog from "./components/TiejunAddDialog";
import { TIEJUN_LEVELS, TIEJUN_LEVEL_MAP } from "src/config/constants";
import BindTeijunParentDialog from "./components/BindTeijunParentDialog";
import TiejunEditDialog from "./components/TiejunEditDialog";
import RejectApplyDialog from "../merchant/components/RejectApplyDialog";
import Label from "src/components/Label";

const levels = Object.values(TIEJUN_LEVELS);

const TABLE_HEAD = [
  { id: "id", label: "ID", alignRight: false },
  { id: "user", label: "用户", alignRight: false },
  { id: "realname", label: "真实姓名", alignRight: false },
  { id: "mobile", label: "手机号", alignRight: false },
  { id: "idNo", label: "身份证号", alignRight: false },
  { id: "parent", label: "辅导员", alignRight: false },
  { id: "status", label: "状态", alignRight: false },
  { id: "createdAt", label: "创建时间", alignRight: false },
  { id: "" },
];

const moreMenus = [
  { title: "通过", icon: iconEdit2 },
  { title: "拒绝", icon: iconEdit2 },
];


export default function TiejunApplyList() {
  const navigate = useNavigate();
  const [selected, setSelected] = useState([]);

  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);

  const [targetItem, setTargetItem] = useState({});
  const [action, setAction] = useState("");

  const [filter, setFilter] = useState({
    page: 0,
    size: 10,
    search: "",
    uid: null,
    level: null,
  });

  const [form, setForm] = useState({
    uid: "",
    orgId: "",
  });

  useEffect(() => {
    getItems();
  }, [filter]);

  async function getItems() {
    const { data, count } = await asyncRequest({
      path: "/user/tiejun/apply/list",
      data: filter,
    });

    setItems(data);
    setTotal(count);
  }

  const handlePageChange = (event, value, newSize) => {
    if (newSize !== undefined) {
      setFilter({ ...filter, page: 0, size: newSize });
      return;
    }
    const newPage = value - 1;
    if (newPage === filter.page) return;
    setFilter({
      ...filter,
      page: newPage,
    });
  };

  const handleFilterByName = (event) => {
    setFilter({
      ...filter,
      search: event.target.value,
    });
  };

  function getMenus(row) {
    return moreMenus.filter((menu) => {
      if (menu.condition) {
        switch (menu.condition) {
          case "pid":
            return !menu.pid;
        }
      }
      return true;
    });
  }

  const handleMoreClick = (type, row) => {
    if (type === "通过") {
      handleAuth(row, 1);
    } else if (type === "拒绝") {
      setTargetItem(row);
      setAction("reject");
    }
  };

  function handleAuth({ id }) {
    Confirm({
      message: "确定通过审核吗？",
      async onConfirm() {
        axios
          .post("/user/tiejun/apply/auth", { id, pass: true })
          .then((res) => {
            const { code, msg } = res.data;
            if (code === 1) {
              getItems();
              alert(msg, "success");
            } else {
              alert(msg);
            }
          })
          .catch((err) => { });
      },
    });
  }

  async function handleReject(form) {
    if (!form.reason) return alert("请输入拒绝理由");
    const { msg } = await asyncRequest({
      path: "/user/tiejun/apply/auth",
      data: {
        reason: form.reason,
        id: targetItem.id,
        status: 2,
      },
    });

    getItems();
    alert(msg, "success");
    setAction("");
  }


  function handleFilterChange(ki, val) {
    setFilter({
      ...filter,
      [ki]: val,
    });
  }

  const isUserNotFound = items.length === 0;

  return (
    <Page title="铁军申请列表">
      <Container maxWidth="2000px">
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            铁军申请列表
          </Typography>

          {/* <Button variant="contained" to="add" startIcon={<Icon icon={plusFill} />} onClick={() => handleAddStaff()}>
            添加铁军
          </Button> */}
        </Stack>

        <Card>
          {/* <ListToolbar filterName={filter.search} onFilterName={handleFilterByName} onRefresh={getItems} /> */}
          <ListToolbar filterName={filter.search} onFilterName={handleFilterByName} onRefresh={getItems}>
            {/* <Grid container>
              <TextField
                style={{ width: 200 }}
                size="small"
                label="用户ID"
                placeholder="用户ID"
                autoComplete="off"
                id="uid"
                value={filter.uid}
                onChange={(e) => {
                  handleFilterChange("uid", e.target.value);
                }}
              />
            </Grid> */}
          </ListToolbar>

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <ListHead headLabel={TABLE_HEAD} />
                <TableBody>
                  {items.map((row) => {
                    const { id, uid, tiejun, user, realname, status, idNo, createdAt, mobile } = row;
                    const isItemSelected = selected.indexOf(realname) !== -1;

                    return (
                      <TableRow hover key={id} tabIndex={-1} role="checkbox" selected={isItemSelected} aria-checked={isItemSelected}>
                        {/* <TableCell padding="checkbox">
                           <Checkbox
                             checked={isItemSelected}
                             onChange={(event) => handleClick(event, uid)}
                           />
                         </TableCell> */}
                        <TableCell align="left">{id}</TableCell>
                        <TableCell component="th" scope="row">
                          <UserInfo {...user} enablePreview />
                        </TableCell>
                        <TableCell align="left">{realname}</TableCell>
                        <TableCell align="left">{mobile}</TableCell>
                        <TableCell align="left">{idNo}</TableCell>
                        <TableCell component="th" scope="row">
                          {tiejun ? <UserInfo {...tiejun.user} enablePreview /> : null}
                        </TableCell>
                        <TableCell align="left">
                          <Label color={["error", "success", "default"][status]}>{["待审核", "已通过", "已拒绝"][status]}</Label>
                        </TableCell>
                        <TableCell align="left">{moment(createdAt).format("YYYY-MM-DD HH:mm:ss")}</TableCell>

                        <TableCell align="right">
                          <MoreMenu spread={true} menus={getMenus(row)} onMoreClick={(type) => handleMoreClick(type, row)} />
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  {/* {emptyRows > 0 && (
                    <TableRow style={{ height: 50 * emptyRows }}>
                      <TableCell colSpan={2} />
                    </TableRow>
                  )} */}
                </TableBody>
                {isUserNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 5 }}>
                        <SearchNotFound searchQuery={filter.search} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <MyPagination total={total} page={filter.page} size={filter.size} onChange={handlePageChange} />
        </Card>
      </Container>



      {action == "reject" && <RejectApplyDialog open onClose={() => setAction("")} onConfirm={handleReject} />}
    </Page>
  );
}
